import { makeRoutes, MakeRoutesOpts, eagerRoute } from "common/router/utils/routes";
import { MakePaths } from "common/router/types";
import { makeUrls } from "common/router/utils/urls";
import { ClientHomeSearch } from "common/types/clinics";

import { INITIAL_CLIENT_DATA } from "client/common/utils";

const paths = {
  root: "/",
};

type HomePathDefinitions = {
  root: { Search: ClientHomeSearch };
};

export type HomePaths = MakePaths<HomePathDefinitions>;

export const useHomeRoutes = (opts: MakeRoutesOpts) => {
  const isHdEnabled = INITIAL_CLIENT_DATA.clinic.primary_tag.is_hd_enabled;

  if (!isHdEnabled && opts.NotFoundComponent) {
    // When HD is disabled, show 404 for any unmatched routes
    return makeRoutes(opts, [
      eagerRoute({
        path: paths.root,
        element: <opts.NotFoundComponent />,
      }),
    ]);
  }

  return makeRoutes(opts, [
    {
      path: paths.root,
      element: () => import("../components/HomePage"),
    },
  ]);
};

export const makeHomeUrls = (base: string) => {
  return makeUrls<HomePathDefinitions>(base, {
    root: { path: paths.root },
  });
};
